import axios from '@/axios'
import router from '@/router'

const getUser = ({commit, dispatch}) => {
  if (localStorage.getItem('token')) {
    axios.get(`/v1/users/me`).then(({ data }) => {
      commit('SET_USER', data)
      commit('SET_LOGGED_IN', true)
      dispatch('getAbilities')
      dispatch('initSystem')

      if (!localStorage.getItem('accountId')) {
        dispatch('setAccount', data.accountId)
      }
    }).catch((err) => {
      if (err.response && err.response.status === 401) {
        commit('CLEAR_NOTIFICATIONS')
        dispatch('notification', {
          group: 'auth',
          title: 'Session Expired',
          text: 'Your session has expired',
          type: 'warn'
        })
        commit('SET_LOGGED_IN', false)
        router.push({name: 'Login'})
        localStorage.removeItem('token')
        localStorage.removeItem('accountId')
      }
    })
  } else {
    commit('SET_USER', null)
  }
}

const login = ({commit, dispatch }, body) => {
  if (!body || !body.username || !body.password) {
    return false
  }

  axios.post(`/v1/auth/login`, body)
    .then(({ data }) => {
      commit('SET_LOGGED_IN', true)
      localStorage.setItem('token', data.token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
      dispatch('getUser')
      router.push({name: 'Dashboard'})
    })
    .catch((err) => {
      if (err.response && err.response.status === 401) {
        commit('SET_LOGIN_ERROR', 'Invalid Username/Password')
      }
    })
}

const clearLoginError = ({commit}) => {
  commit('SET_LOGIN_ERROR', null)
}

const logout = ({commit}) => {
  if (localStorage.getItem('token')) {
    axios.post(`/v1/auth/logout`)
      .then(({status}) => {
        if (status === 200) {
          commit('SET_LOGGED_IN', false)
          axios.defaults.headers.common['Authorization'] = null
          localStorage.removeItem('token')
          localStorage.removeItem('accountId')
          // dispatch('getUser')
          router.push({name: 'Login'})
        }
      })
  }
}

export default {
  // init,
  clearLoginError,
  getUser,
  login,
  logout
}
